import { loc } from '@okta/courage';
export default {
  title() {
    return loc('oie.email.mfa.title', 'login');
  }
};
